module.exports = __webpack_public_path__ + "static/media/3680.ec84d2bc.jpg";